import React, { useEffect, useState } from 'react';
import { ECMID } from '../../../constants';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumb from '../../../component/Breadcrumb';
import { Grid, Typography, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import swal from 'sweetalert';
import FormNumberField from '../../../component/NumberInput';

const AddNewDefinition = () => {
    const location = useLocation();
    const [fields,setFields] = useState({
        ECMID        : '',
        CANPORT      : '',
        CommLossDel  : '',
        FixSrcAddr   : '',
        ArbCap       : '',
        IndGrp       : '',
        VehSysInst   : '',
        VehSys       : '',
        Fun          : '',
        FunInst      : '',
        ECUInst      : '',
        MfrCode      : '',
        ID           : '',
    })

    useEffect(()=> {
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){
            let existingDefinitions = JSON.parse(localStorage.getItem('ECUIDDefinitions'));
            setFields(existingDefinitions[location.state?.rowId])
        }
    },[location.state?.rowId])

    const changeHandler = (e) => {
        let value = e.target.name === 'CANPORT' ? e.target.value.replace(/\D/g, "") : e.target.value;
        let name  = e.target.name;
        //setFields((prevState) => ({...prevState, [name]: isNaN(parseInt(value)) ? '' : parseInt(value)}))
        setFields((prevState) => ({...prevState, [name]: e.target.name !== 'CANPORT' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    }

    const handleBlurUpdate = (name,value) => {
        setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 

    const handleSubmit = () => {
        const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(isEmpty){
            swal("Oops!", "Please fill required fields!", "error");
            return false;
        }
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){
            let existingDefinitions = JSON.parse(localStorage.getItem('ECUIDDefinitions'));
            existingDefinitions[location.state?.rowId] = fields;
            localStorage.setItem('ECUIDDefinitions',JSON.stringify(existingDefinitions));
            swal({
                title: "Success",
                text: 'ECUID Definitions updated successfully.',
                icon: "success",
            })
        } else {
            let existingDefinitions = JSON.parse(localStorage.getItem('ECUIDDefinitions'));
            if(existingDefinitions == null) existingDefinitions = [];
            existingDefinitions.push(fields);
            localStorage.setItem('ECUIDDefinitions',JSON.stringify(existingDefinitions));
            swal({
                title: "Success",
                text: 'ECUID Definitions added successfully.',
                icon: "success",
            })
            setFields({
                ECMID        : '',
                CANPORT      : '',
                CommLossDel  : '',
                FixSrcAddr   : '',
                ArbCap       : '',
                IndGrp       : '',
                VehSysInst   : '',
                VehSys       : '',
                Fun          : '',
                FunInst      : '',
                ECUInst      : '',
                MfrCode      : '',
                ID           : '',
            })
        }
    }

    return (
        <>
            <Breadcrumb title={location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'Add New' }>
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to={location.pathname.includes('mapping') ? '/mapping/can/definitions' : '/can/definitions'} variant="subtitle2" color="primary" className="link-breadcrumb">
                   ECUIDDefinitions
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                {location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'New' }
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">

                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link}
                                to={location.pathname.includes('mapping') ? '/mapping/can/definitions' : '/can/definitions'}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="ECMID"
                                    value={fields.ECMID}
                                    onChange={changeHandler}
                                    name="ECMID"
                                    error={fields.ECMID === ""}
                                >
                                    <MenuItem value="">Select ECMID</MenuItem>
                                    {ECMID?.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" ? "Required Field!" : false}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="CANPORT"
                                label="CANPORT"
                                name="CANPORT"
                                value={fields.CANPORT}
                                onChange={changeHandler}
                                error={fields.CANPORT === ""}
                                helperText={fields.CANPORT === "" ? "Required Field!" : false}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="CommLossDel"
                                label="CommLossDel"
                                name="CommLossDel"
                                value={fields.CommLossDel}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="FixSrcAddr"
                                label="FixSrcAddr"
                                name="FixSrcAddr"
                                value={fields.FixSrcAddr}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="ArbCap"
                                label="ArbCap"
                                name="ArbCap"
                                value={fields.ArbCap}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="IndGrp"
                                label="IndGrp"
                                name="IndGrp"
                                value={fields.IndGrp}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="VehSysInst"
                                label="VehSysInst"
                                name="VehSysInst"
                                value={fields.VehSysInst}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="VehSys"
                                label="VehSys"
                                name="VehSys"
                                value={fields.VehSys}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Fun"
                                label="Fun"
                                name="Fun"
                                value={fields.Fun}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="FunInst"
                                label="FunInst"
                                name="FunInst"
                                value={fields.FunInst}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="ECUInst"
                                label="ECUInst"
                                name="ECUInst"
                                value={fields.ECUInst}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="MfrCode"
                                label="MfrCode"
                                name="MfrCode"
                                value={fields.MfrCode}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="ID"
                                label="ID"
                                name="ID"
                                value={fields.ID}
                                onBlurUpdate={handleBlurUpdate}
                                error={true}
                                helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/definitions' : '/can/definitions'}
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                </Grid>
            </Box>
        </>
    );
};

export default AddNewDefinition;
